import HttpService from '@/shared/services/HttpService';

class LeaguesService {
    private http = new HttpService();
    public async fetchUserleagues() {
        try {
            const response = await this.http.get('ap/leagues');
            return response["hydra:member"].map((league: any) => ({
                id: league.id,
                title: league.title,
            }));
        } catch (e) {
            return e;
        }
    }
    public async fetchLeagueParticipants(id: number) {
        try {
            const result =  await this.http.get(`ap/leagues/${id}/games`);
            return result['hydra:member'].map((x: any) => ({username: x.user.username, id: x.user.ref, score: x.score, rank: x.rank}));
        } catch (e) {
            return e;
        }
    }

        public async fetchLeagueTransfers(id: number) {
        console.log(id);
        try {
            return await this.http.get(`ap/league_transfers​/${id}`);
        } catch (e) {
            return e;
        }
    }
    public async fetchLeagueProfileInfo(leagueId: number) {
        try {
            return await this.http.get(`ap/leagues/${leagueId}`);
        } catch (e) {
            return e;
        }
    }
    public async fetchLeagueMarket(leagueId: number) {
        try {
            return await this.http.get(`ap/league_markets/${leagueId}`);
        } catch (e) {
            return e;
        }
    }
    public async fetchProfileNews(leagueId: number) {
        try {
            const response = await this.http.get(`ap/leagues/${leagueId}/news`);
            return response["hydra:member"].map((league: any) => ({
                id: league.id,
                title: league.title,
            }));
        } catch (e) {
            return e;
        }
    }
}

export default new LeaguesService();
